jQuery(document).ready(function($) {
  $('.faq_item').on('click', function(){
    if($(this).hasClass('active')){
      $(this).toggleClass('active');
    }else{
      $('.faq_item').removeClass('active');
      $(this).toggleClass('active');
    }
    
    
  });
});